import { observable } from 'mobx';

import { ContextStore, SerializedData, Store } from 'bernie-core';
import { getBexApiContext } from 'bernie-context';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

import { BexApiSource } from 'sources/bex-api-source';

import { PropertyInfoPageLayout } from '__generated__/api';

export class PageLayoutStore extends Store {
  public static DEFAULT_PDP_TEMPLATE_NAME: string = 'CONVENTIONAL_LODGING';

  private static viewComposerTemplates = ['SINGLE_UNIT_VR'];
  public static shouldUseViewComposer = (templateName: string): boolean => PageLayoutStore.viewComposerTemplates.includes(templateName);

  @observable
  public templateName: string;

  constructor(private bexApiSource: BexApiSource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    delete data.source;
    delete data.bexApiSource;

    this.templateName = data.templateName;
  }

  public async fetchPDP(propertyId: string, context: ContextStore, isPackagePath): Promise<string> {
    if (isPackagePath) {
      this.templateName = PageLayoutStore.DEFAULT_PDP_TEMPLATE_NAME;
    } else {
      const variables: PropertyInfoPageLayout.Variables = this.buildVariables(context, propertyId);

      const result = await this.bexApiSource.fetchPageLayoutTemplate(variables);

      const templateName = result?.data?.propertyInfo?.experimental?.pageLayoutExperimentalFeature?.templateName;

      this.templateName = templateName || PageLayoutStore.DEFAULT_PDP_TEMPLATE_NAME;
    }

    return this.templateName;
  }

  private buildVariables(context: ContextStore, propertyId: string): PropertyInfoPageLayout.Variables {
    return {
      context: getBexApiContext(context),
      shoppingContext: null,
      propertyId,
    };
  }
}
